import cssVariables from 'tfs.css-variables'

export default {
  form: {
    display: 'flex',
    width: '66rem',
    margin: '3rem auto',
    alignItems: 'center',
    boxShadow: '0 0.187rem 0.5rem 0 rgba(0, 0, 0, 0.12)',
    backgroundColor: cssVariables.colorWhite,
    padding: '0.7rem',
    borderRadius: '0.5rem',

    '& > *': {
      marginRight: '1rem',
      borderRight: `thin solid ${cssVariables.colorGrayE}`,

      '&:not(:last-child)': {
        padding: '0 1rem',
      },

      '& input': {
        border: '1px solid transparent',
        padding: '0.4rem',
        marginLeft: '-0.4rem',
      },
    },
  },
}
